const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/", "/contactus"],
    exact: true,
    component: "ContactUs",
  },
];

export default routes;
